import { useLocale } from "hooks";
import { useEffect, useState } from "react";
import { ApiService } from "services/serverInClient";
import translation from "./translation";
import Doc from "components/Doc";
import CustomChart from './CustomChart';

const normalizer = (item) => {
  return {
    title: item?.metadata?.displayName || "",
    id: item?.id || "",
    parentId: item?.parent || "",
    children: item?.children?.map(normalizer) || []
  }
}

const OrganizationRenderer = ({ tabData }) => {
  const [parentWithChildren, setParentWithChildren] = useState(null)
  const { locale, isRTL } = useLocale();

  useEffect(() => {
    const fetchTagTrees = async () => {
      const apiService = new ApiService(locale);
      let response = await apiService.getOrganizationTagTrees(tabData.tagtreeId);
      let normalized = normalizer(response?.result?.[0])
      if (normalized?.children.length > 0) {
        setParentWithChildren(normalized);
      } else {
        response = await apiService.getOrganizationTagTrees(normalized.parentId);
        normalized = normalizer(response?.result?.[0]);
        setParentWithChildren(normalized);
      }
    };
    fetchTagTrees()
  }, [tabData.tagtreeId]);

  return (
    <div className="tw-bg-white tw-p-5 xxxl:tw-p-[26.67px] tw-rounded-[16px] tw-border-[#E5E9F4] tw-border tw-my-8"
      style={{ boxShadow: "0 1px 3px 0 hsl(0deg 0% 72% / 60%)" }}>
      <div dir="ltr" className="tw-mt-10">
        {/* <Tree
            lineHeight={'52px'}
            lineWidth={'2px'}
            lineColor={'#94A3B8'}
            lineBorderRadius={'0px'}
            label={
              <StyledNode className="organization-label-root" isRoot id={`organization-label-${parentWithChildren?.id}`} isActive={+tabData.tagtreeId === +parentWithChildren?.id}>
                <div className="tw-flex tw-items-center tw-h-full tw-w-full tw-group" dir="rtl">
                  {parentWithChildren?.title}
                  {tabData?.user?.title && <PersonCard user={tabData.user} />}
                </div>
              </StyledNode>
            }
          >
            {parentWithChildren?.children?.map(child => <TreeNode key={child.id} label={<StyledNode className="organization-label-child" isActive={+tabData.tagtreeId === +child.id} id={`organization-label-child-${child.id}`}><div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full">{child.title}</div></StyledNode>} />)}
          </Tree> */}
        <CustomChart parentWithChildren={parentWithChildren} tabData={tabData} />
      </div>
      <div>
        <h1 className="tw-text-[#336592] tw-text-[22px] tw-font-bold tw-my-6">{tabData.title}</h1>
        {tabData.content ? (
          <Doc ltr={!isRTL}>
            <div className="doc">
              <div dangerouslySetInnerHTML={{ __html: tabData.content }}></div>
              {/* {HtmlParser(t?.content)} */}
            </div>
          </Doc>
        ) : (
          <div className="tw-text-center">
            {translation[locale]?.NO_CONTENT}
          </div>
        )}
      </div>
    </div>
  )
};

export default OrganizationRenderer;